<template>
    <div class="index_content">
        <div class="f-row">
            <Breadcrumb separator=">" class="breadcrumb_zdy">
                当前位置:
                <BreadcrumbItem :to="{name: 'PolicyList'}">政策</BreadcrumbItem>
                <BreadcrumbItem>政策详情</BreadcrumbItem>
            </Breadcrumb>
            <div>
                <!-- <a href="javascript:history.back(-1)" ><i class="iconfont-sm">&#xe661;</i> 返回上一级页面</a> -->
            </div>
        </div>
        <div class="policy-index">
            <table class="policy-info">
                <tr>
                    <td width="110">发文机关</td>
                    <td width="250">{{detail.publish_org | empty}}</td>
                    <td width="110">发文字号</td>
                    <td width="250">{{detail.code | empty}}</td>
                    <td width="110">发文时间</td>
                    <td>{{detail.publish_time | time_moment}}</td>
                </tr>
                <tr>
                    <td width="110">有效地区</td>
                    <td width="250">{{detail.address_id | addressDeal('3')}}</td>
                    <td width="110">时效性</td>
                    <td width="250">{{detail.available | empty}}</td>
                    <td width="110">实施时间</td>
                    <td>{{detail.execute_time | time_moment}}</td>
                </tr>
            </table>
            <div class="policy-content">
                <p class="title">{{detail.name}}</p>
                <div class="dec">
                    {{detail.code}}
                    <div class="collect_share">
                        <i class="iconfont s active" title="取消收藏" v-if="detail.is_collect > 0" @click="cancelCollect('3', detail.id, delCollectCb)">&#xe66f;</i>
                        <i class="iconfont s" title="收藏" v-else  @click="addCollect('3', detail.id, addCollectCb)">&#xe66f;</i>
                        <Poptip trigger="hover" placement="bottom-end" padding="0" width="248" @on-popper-show="haddleShare(dataLi)" @on-popper-hide="haddleShareHide">
                            <i class="iconfont w">&#xe641;</i>
                            <div slot="content" class="share_cnt clear">
                              <div class="share_img"></div>
                              <p>打开微信“扫一扫”<br />点击右上角分享按钮</p>
                            </div>
                        </Poptip>
                    </div>
                </div>
                <div class="text-part" v-html="detail.unsined_content"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { policyDetail } from '../../service'
import { collect_mixin } from 'js/collect_mixin'
export default {
  mixins: [ collect_mixin ],
  data() {
    return {
      spinShow: false,
      detail: ''
    }
  },
  methods: {
    addCollectCb() {
      this.detail.is_collect = 1
    },
    delCollectCb() {
      this.detail.is_collect = 0
    },
    haddleShare(item) {
      let share_link = window.location.href
      jQuery($('.share_img')).qrcode({
        width: 80,
        height: 80,
        correctLevel: 0,
        text: share_link
      })
    },
    haddleShareHide() {
      $('.share_img').html('')
    },
    async getPolicyDetail(){
      let res = await policyDetail({
        uid: this.$route.params.uid,
        user_key: this.$store.state.user_key
      }, (error) => {
            this.$Message.error('请求错误！')
          })
      if(res.status == 'success'){
        this.$set(this.$data, 'detail', res.res)
      } else {
        this.$Message.error(res.msg)
      }
      this.spinShow = true
    }
  },
  created() {
    this.getPolicyDetail()
  }
}
</script>

<style scoped lang="stylus">
@import '~styles/common.stylus'
@import '~styles/collect_share.stylus'
.index_content
  padding: 16px 0 20px
  .policy-index
    width: 1000px
    margin: 20px auto
    .policy-info
      width: 100%
      tr
        td
          font-size: 14px
          commonColor(#E9E9EB, #333333)
          line-height: 22px
          height: 48px
          &:nth-of-type(even)
            commonBgColor(#1f2330, #FFFFFF)
            padding: 10px 20px
          &:nth-of-type(odd)
            commonBgColor(#2A2F42, #FFFAF5)
            commonColor(#E9E9EB, #666666)
            padding-left: 28px
            font-weight: bold
        &+tr
          border-top: 1px solid
          commonBorderColor(#40444F, #F4F6F8)
    .policy-content
      position: relative
      margin-top: 16px
      commonBgColor(#1f2330, #FFFFFF)
      padding: 40px 80px
      .collect_share
        position: absolute
        right: 0
        top: 0
      .title
        width: 700px
        font-size: 28px
        line-height: 36px
        margin: -4px auto
        text-align: center
        commonColor(#E9E9EB, #333333)
        font-weight: 600
        font-weight: bold
      .dec
        font-size: 16px
        commonColor(#797B83, #999999)
        line-height: 18px
        height: 18px
        text-align: center
        margin-top: 16px
        padding: 0 100px
        position: relative
      .text-part
        font-size: 16px
        commonColor(#E9E9EB, #333333)
        line-height: 28px
        margin-top: 30px
        img
          max-width: 100%
</style>
